import { MmcDataSource } from '../index';
import { configs } from '../configs';
import { memoizeWithAllArgsHashed as memoize } from '../utils';

export const settingsQueries = {
  getFtpSettings: (storeId) => {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.ftpSettings(storeId),
    });
    return entity.find();
  },
  createFtpSettings: (storeId, data) => {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.ftpSettings(storeId),
    });
    return entity.create(data);
  },
  updateFtpSettings: (storeId, data) => {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.ftpSettings(storeId),
    });
    return entity.update(null, data);
  },
  getShippingSettings: (storeId, market) => {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.shippingSettings(storeId),
    });
    const params = {
      query: {
        $expand: 'ShippingLabels',
      },
    };
    return entity.find(`'${market}'`, params);
  },
  updateShippingSettings: (storeId, market, data) => {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.shippingSettings(storeId),
    });
    return entity.update(`'${market}'`, data);
  },
  getAutoUpdateSettings: (storeId, market) => {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.automaticItemUpdateSettings(storeId),
    });
    return entity.find(`'${market}'`);
  },
  updateAutoUpdateSettings: (storeId, market, data) => {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.automaticItemUpdateSettings(storeId),
    });
    return entity.update(`'${market}'`, data);
  },
  getLinkedManagerAccountsSettings: (storeId) => {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.linkedManagerAccountsSettings(storeId),
    });
    return entity.find();
  },
  updateLinkedManagerAccountsSettings: (storeId, data) => {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.linkedManagerAccountsSettings(storeId),
    });
    return entity.update(null, data);
  },
  getConsolidatedMatchedReport: (storeId) => {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.downloadConsolidatedMatchedReport(storeId),
    });
    return entity.find();
  },
  getMatchedReport: (storeId, coOpInternalProviderId) => {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.downloadMatchedReport(storeId, coOpInternalProviderId),
    });
    return entity.find();
  },
  acceptLinkRequests: (storeId, data) => {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.acceptLinkedCustomerRequests(storeId),
    });
    return entity.create(data);
  },
  declineLinkRequests: (storeId, data) => {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.declineLinkedCustomerRequests(storeId),
    });
    return entity.create(data);
  },
  unlinkCustomers: (storeId, data) => {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.unlinkCustomers(storeId),
    });
    return entity.create(data);
  },
  getLinkedCustomerList: (storeId) => {
    const entity = memoize(sid =>
      new MmcDataSource({
        entityName: '',
        routePrefix: configs.routes.oDataRoute,
        endpoint: configs.endpoints.linkedCustomerList(sid),
      }))(storeId);
    return {
      type: 'jsdata',
      entity,
      primaryKey: 'CustomerId',
      query: {},
    };
  },
  getProductListingsSettings: (storeId) => {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getProductListingsSettings(storeId),
    });
    return entity.find();
  },
  updateProductListingsSettings: (storeId, data) => {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.updateProductListingsSettings(storeId),
    });
    return entity.update(null, data);
  },
  getAllAggregators: () => {
    const entity = new MmcDataSource({
      entityName: '',
      noScope: true,
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getAllAggregators(),
    });
    return entity.find();
  },
  getAggregatorsSettings: (storeId) => {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getAggregatorsSettings(storeId),
    });
    return entity.find();
  },
  updateAggregatorsSettings: (storeId, data) => {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getAggregatorsSettings(storeId),
    });
    return entity.post(null, data);
  },
};
